import type { UsageTotals } from '@autopilot/contracts';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { AlertTriangle } from 'lucide-react';
import { formatTokensPerResolved, formatUsage, usageHint } from '../lib/tokens';

export function TokenValue({ usage }: { usage: UsageTotals | null | undefined }) {
  const hint = usageHint(usage);
  return (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
      {hint && (
        <Tooltip title={hint}>
          <Box component="span" sx={{ display: 'inline-flex', color: 'var(--color-warning)' }} aria-label={hint}>
            <AlertTriangle size={15} />
          </Box>
        </Tooltip>
      )}
      <span>{formatUsage(usage)}</span>
    </Box>
  );
}

export function TokensPerResolved({ value, usage }: { value: number | null | undefined; usage: UsageTotals | null | undefined }) {
  return <span>{formatTokensPerResolved(value, usage)}</span>;
}
